import { IconCircleCheckFilled, IconInfoCircleFilled, IconInfoTriangleFilled } from '@tabler/icons-react';
import classNames from 'classnames';
import s from './alert.module.scss'
import { motion } from 'framer-motion';

const icons = {
  danger: <IconInfoCircleFilled color='red' size={24}/> ,
  success: <IconCircleCheckFilled color='#179F25' size={24}/>,
  warning: <IconInfoTriangleFilled color='#F87728' size={24}/>,
};

export const Alert = ({ title, subtitle, type = 'warning', index = crypto.getRandomValues(new Uint32Array(1)) }) => {
  const Icon = icons[type];

  return (
		<motion.div initial={{
					y: -50,
					x: 0,
					opacity: 0,
				}} 
				animate={{
					y: 0,
					x: 0,
					opacity: 1,
				}}
				exit={{
					y: 0,
					opacity: 0,
				}}>
			<div className={classNames(s.alert, s[type])}>
				{Icon}
				<div className={s.content}>
					<h3>{title}</h3>
					{subtitle && <p>{subtitle}</p>}
				</div>
			</div>
		</motion.div>
  );
};